"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _AutoComplete = _interopRequireDefault(require("./AutoComplete"));
var AutoComplete = function AutoComplete(props) {
  return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(props.prefixCls, "-wrapper")
    }, /*#__PURE__*/_react.default.createElement(_AutoComplete.default, (0, _extends2.default)({
      theme: theme
    }, props)));
  });
};
AutoComplete.defaultProps = {
  prefixCls: 'ykb-auto-complate',
  size: 'default'
};
AutoComplete.propTypes = {
  prefixCls: _propTypes.default.string,
  size: _propTypes.default.oneOf(['default', 'large', 'small']),
  notFoundContent: _propTypes.default.any,
  loading: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  allowClear: _propTypes.default.bool,
  renderExtraFooter: _propTypes.default.object,
  optionLabelProp: _propTypes.default.oneOf(['value', 'children']),
  optionFilterProp: _propTypes.default.string,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
  valueKey: _propTypes.default.string,
  labelKey: _propTypes.default.string,
  tooltipOptions: _propTypes.default.shape({
    renderToolTip: _propTypes.default.func,
    hiddenLabels: _propTypes.default.array
  }),
  options: _propTypes.default.arrayOf(_propTypes.default.object),
  onChange: _propTypes.default.func,
  onSearch: _propTypes.default.func,
  onSelect: _propTypes.default.func
};
var _default = exports.default = AutoComplete;